import { render } from "./SendSmsWithTemplate.vue?vue&type=template&id=100f5822"
import script from "./SendSmsWithTemplate.vue?vue&type=script&lang=js"
export * from "./SendSmsWithTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafepayam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__